import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Modal, Accordion, Card } from 'react-bootstrap'
import API from '../Components/Global_API'
import { Icon } from 'react-icons-kit'
import { trashO, plus } from 'react-icons-kit/fa'
import { smallRight, smallLeft } from 'react-icons-kit/entypo'
import './drag_to_match.css'
import NoInternet from '../Components/NoInternet';

const styles = {
    body: {
        backgroundColor: '#34baeb',
    },
    dot_btn: {
        borderWidth: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
    },
    done_btn: {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        marginBottom: 30,
        color: '#fff',
        borderWidth: 1,
        borderColor: '#fff',
        fontWeight: 'bold'
    },
    disable_done_btn: {
        marginBottom: 30,
        color: '#fff',
        fontWeight: 'bold'
    },
    upload_button_label: {
        backgroundColor: '#fff',
        marginBottom: 5,
        borderWidth: 1,
        borderColor: '#fff',
        fontWeight: 'bold'
    },
    text: {
        fontWeight: '700',
        fontSize: 13
    },
    textbox: {
        height: 30
    },
    previewbutton: {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        marginBottom: 30,
        borderWidth: 1,
        padding: 20,
        borderColor: '#fff',
        color: '#fff',
        width: "100%",
    }
}


export default class Drag_to_match extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lesson_id: this.props.data.lesson_id,
            title: this.props.data.title,
            answer_text: this.props.data.answer_text,
            correct_reinforcement: this.props.data.correct_reinforcement,
            incorrect_reinforcement: this.props.data.incorrect_reinforcement,
            prompt: this.props.data.prompt,
            done_text: this.props.data.done_text,
            prev_review: true,
            question_id: this.props.data.question_id,
            todos: this.props.data.drag_to_match_options,
            course_image: this.props.data.course_image,
            changeSectionStatus: '',
            PublishedSectionPopup: false,
            done_button_state: true,
            image_error_popup: false
        }

        this.Add = this.Add.bind(this);
        this.Remove = this.Remove.bind(this);
    }

    handlePreview = () => {
        this.setState({ prev_review: false })
    }

    handleReviewLastSlide = () => {
        this.handlePrevButton(this.props.current_index - 1)
        this.state.prevbutton = true
    }

    handleRestartLesson = () => {
        this.handlePrevButton(0)
        this.state.prevbutton = true
    }

    handleCancel = () => {
        this.setState({ prev_review: true })
    }


    handleSubmit = () => {
        if (this.state.title.trim().length < 2 || this.state.title.trim().length > 250) {
            document.getElementById("title").focus()
        } else if (this.state.contentValidation) {
            console.log("error");
        } else if (this.state.correct_reinforcement.trim().length < 2 || this.state.correct_reinforcement.trim().length > 50) {
            document.getElementById("correct_reinforcement").focus();
        } else if (this.state.incorrect_reinforcement.trim().length < 2 || this.state.incorrect_reinforcement.trim().length > 50) {
            document.getElementById("incorrect_reinforcement").focus();
        } else if (this.state.prompt.trim().length < 2 || this.state.prompt.trim().length > 50) {
            document.getElementById("prompt").focus();
        } else if (this.state.done_text.trim().length < 2 || this.state.done_text.trim().length > 30) {
            document.getElementById("done_text").focus();
        } else {

            let data = [];
            this.state.todos.map((item, i) => (
                data.push({ left_content: item.left_content, right_content: item.right_content })
            ))
            let Create_drag_to_match = JSON.stringify({
                lesson_id: this.state.lesson_id,
                title: this.state.title,
                options_data: data,
                answer_text: this.state.answer_text,
                correct_reinforcement: this.state.correct_reinforcement,
                incorrect_reinforcement: this.state.incorrect_reinforcement,
                prompt: this.state.prompt,
                done_text: this.state.done_text,
                drag_to_match_id: this.state.question_id
            })

            fetch(API + 'edit_drag_to_match.php',
                {
                    method: 'POST',

                    body: Create_drag_to_match
                }).then((response) => response.json()).then((responseJsonFromServer) => {
                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                    if (responseJsonFromServer.result === 'success') {
                        x.innerHTML = responseJsonFromServer.msg;
                        setTimeout(() => {
                            this.props.handleUpdateQuetionData();
                        }, 2000);

                    } else {
                        x.innerHTML = responseJsonFromServer.msg;
                    }

                }).catch((error) => {
                    if (error.message == 'Failed to fetch') {
                        this.setState({ networkError: true })
                    }
                });
        }
    }

    promptValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_prompt')[0].innerHTML = "Prompt is required.";
            document.getElementsByClassName('error_prompt')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 50) {
            document.getElementsByClassName('error_prompt')[0].innerHTML = 'Prompt must be between 2 to 50 character.';
            document.getElementsByClassName('error_prompt')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_prompt')[0].innerHTML = "";
            document.getElementsByClassName('error_prompt')[0].style.display = 'none';
        }
    }

    doneTextValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length === 0) {
            document.getElementsByClassName('error_done_text')[0].innerHTML = "Done text is required.";
            document.getElementsByClassName('error_done_text')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 30) {
            document.getElementsByClassName('error_done_text')[0].innerHTML = 'Done text must be between 2 to 30 character.';
            document.getElementsByClassName('error_done_text')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_done_text')[0].innerHTML = "";
            document.getElementsByClassName('error_done_text')[0].style.display = 'none';
        }
    }


    handleChangeTitle = (e) => {
        this.setState({ title: e.target.value });
    }

    handleChangeNo_uploaded_message = (e) => {
        this.setState({ no_uploaded_message: e.target.value });
    }

    handleChangeUpload_button_label = (e) => {
        this.setState({ upload_button_label: e.target.value });
    }

    handleChangePrompt = (e) => {
        this.setState({ prompt: e.target.value });
    }

    handleChangeDone_text = (e) => {
        this.setState({ done_text: e.target.value });
    }

    handleDoneButton = (current_index) => {
        this.props.nextQuestion(current_index)
    }

    handlePrevButton = (current_index) => {
        this.props.nextQuestion(current_index)
    }

    handleChangeAnswerText = (e) => {
        this.setState({ answer_text: e.target.value });
    }

    handleChangeCorrectAns = (e) => {
        this.setState({ correct_reinforcement: e.target.value });
    }

    handleChangeIncorrectAns = (e) => {
        this.setState({ incorrect_reinforcement: e.target.value });
    }

    handleTitleValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_title')[0].innerHTML = "Title is required.";
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 250) {
            document.getElementsByClassName('error_title')[0].innerHTML = 'Title must be between 2 to 250 character.';
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_title')[0].innerHTML = "";
            document.getElementsByClassName('error_title')[0].style.display = 'none';
        }
    }

    rightContentValidation = (i, e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length === 0) {
            document.getElementsByClassName('error_right_content' + i)[0].innerHTML = "Right content is required.";
            document.getElementsByClassName('error_right_content' + i)[0].style.display = 'block';
            this.setState({ contentValidation: true })
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 100) {
            document.getElementsByClassName('error_right_content' + i)[0].innerHTML = 'Right content must be between 2 to 100 character.';
            document.getElementsByClassName('error_right_content' + i)[0].style.display = 'block';
            this.setState({ contentValidation: true })
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_right_content' + i)[0].innerHTML = "";
            this.setState({ contentValidation: false })
            document.getElementsByClassName('error_right_content' + i)[0].style.display = 'none';
        }
    }

    correct_reinforcementValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length === 0) {
            document.getElementsByClassName('error_correct_reinforcement')[0].innerHTML = "Correct reinforcement is required.";
            document.getElementsByClassName('error_correct_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 50) {
            document.getElementsByClassName('error_correct_reinforcement')[0].innerHTML = 'Correct reinforcement must be between 2 to 50 character.';
            document.getElementsByClassName('error_correct_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_correct_reinforcement')[0].innerHTML = "";
            document.getElementsByClassName('error_correct_reinforcement')[0].style.display = 'none';
        }
    }

    incorrect_reinforcementValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length === 0) {
            document.getElementsByClassName('error_incorrect_reinforcement')[0].innerHTML = "Incorrect reinforcement is required.";
            document.getElementsByClassName('error_incorrect_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 50) {
            document.getElementsByClassName('error_incorrect_reinforcement')[0].innerHTML = 'Incorrect reinforcement must be between 2 to 50 character.';
            document.getElementsByClassName('error_incorrect_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_incorrect_reinforcement')[0].innerHTML = "";
            document.getElementsByClassName('error_incorrect_reinforcement')[0].style.display = 'none';
        }
    }

    handleClick = (id) => (e) => {
        this[`textInput${id}`].focus();
        this[`textInput${id}`].click();
    }

    handleChangeContent = async (i, e) => {
        if (e.target.files[0]) {
            var fileName = e.target.files[0].name;
            var idxDot = fileName.lastIndexOf(".") + 1;
            var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
            if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                let users = this.state.todos;
                users.map((item, index) => {
                    if (index == i) {

                        let files = e.target.files;
                        item.ImageName = fileName
                        let reader = new FileReader();
                        reader.readAsDataURL(files[0])
                        reader.onload = (e) => {

                            if (e.target.result) {
                                item.left_content = e.target.result;
                            }
                        }
                    }
                })

                await this.setState({ todos: users });

                var formdata = new FormData();
                formdata.append('file1', document.getElementById('file1' + i).files[0]);

                var request = new XMLHttpRequest();
                var x = document.getElementById("Video_uploading_percent" + i)

                request.upload.addEventListener('progress', function (e) {
                    var file1Size = document.getElementById('file1' + i).files[0].size;
                    if (e.loaded <= file1Size) {
                        var percent = Math.round(e.loaded / file1Size * 100);
                        var loader = document.getElementById('progress-bar-file1' + i)
                        loader.style.width = `${percent}%`;
                        x.innerHTML = percent + '%'
                    }

                    if (e.loaded == e.total) {
                        var loader = document.getElementById('progress-bar-file1' + i)
                        loader.style.width = `${100}%`;
                        x.innerHTML = 100 + '%'
                    }
                });
                request.open('post', '/echo/html/');
                request.timeout = 45000;
                request.send(formdata);

            } else {
                this.setState({ image_error_popup: true })
            }
        }
    }

    handleRightContent = async (i, e) => {
        let value = e.target.value;
        let users = this.state.todos;
        users.map((item, index) => {
            if (index === i) {
                item.right_content = value;

            }
        })
        await this.setState({ todos: users });
    }

    handleKeyDown = (e) => {
        e.target.style.height = 'inherit';
        e.target.style.height = `${e.target.scrollHeight}px`;
    }

    Add() {
        let add = this.state.todos;
        if (this.state.todos.length < 3) {
            let newu = { left_content: 'data:image/png;base64,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', right_content: 'product' }
            add.push(newu)
            this.setState({
                todos: add,
            })
        }


    }

    handleSectionStatusPopupOpen(item) {
        this.setState({
            PublishedSectionPopup: true,
            changeSectionStatus: item
        });
    }

    handlePublishedSectionPopup = () => {
        this.setState({ PublishedSectionPopup: false });
    }

    Remove = async (i, e) => {

        var i = this.state.changeSectionStatus;
        let users = this.state.todos;
        if (this.state.todos.length > 2) {
            users.splice(i, 1);
            await this.setState({ todos: users, PublishedSectionPopup: false });
        }
    }


    dragStart = (event) => {
        event.dataTransfer.setData("Text", event.target.id);

        this.setState({ done_button_state: false })


    }

    dragEnd = (event) => {
        var elmnt = document.getElementById(event.target.id);
        elmnt.style.display = 'inline';
    }

    drag = (event) => {
        var elmnt = document.getElementById(event.target.id);
        elmnt.style.display = 'none';
    }

    allowDrop = (event) => {
        event.preventDefault();
    }

    leftDrop = (event) => {

        event.preventDefault();
        var data = event.dataTransfer.getData("Text");
        if (data == 'dragtarget' + event.target.id) {
            event.target.appendChild(document.getElementById(data));
            if (document.getElementById("text" + event.target.id).classList.length > 0) {
                document.getElementById("text" + event.target.id).classList.remove('dragVisibility');
            }

        }
    }

    rightDrop = (event) => {
        event.preventDefault();
        var data = event.dataTransfer.getData("Text");
        if (data == 'dragtarget' + event.target.id) {
            event.target.appendChild(document.getElementById(data));
            document.getElementById("text" + event.target.id).classList.add('dragVisibility');
        }

    }

    render() {
        if (this.state.networkError) {
            return <NoInternet />
        } else {
            return (
                <div className="row text-center">
                    <div className="col-lg-5 col-md-5 col-sm-12">
                        <div className="card card-sm">
                            <div className="card-content block-xl"  >
                                <div className="body-container" style={styles.body}>
                                    <div className="container-fluid" style={{ height: 550, padding: 0, backgroundPosition: 'center', backgroundSize: 'cover', backgroundImage: `url(${this.state.course_image})` }}>
                                        <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', height: 550, paddingTop: 10, paddingLeft: 15, paddingRight: 15 }}>
                                            <div className="row text-center">
                                                <div style={{ width: '10%', paddingLeft: 5 }}>
                                                    <img src={require('../../assets/pta-logo2.png')} style={{ width: 30, height: 30 }} />
                                                </div>
                                                <div style={{ paddingTop: 15, width: '60%' }}>
                                                    <hr color='#fff' />
                                                </div>
                                                <div style={{ width: '30%', paddingLeft: 5, paddingRight: 5 }}>
                                                    <div style={styles.dot_btn}>
                                                        <label style={{ color: '#fff', fontSize: '80%', padding: 4 }}>{this.props.current_index + 1} / {this.props.que_count}</label>
                                                        <img onClick={this.handlePreview} src={require('../../assets/Dot.png')} style={{ width: 25, height: 25, marginTop: -3, marginLeft: 10, cursor: 'pointer' }} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ height: 380, paddingTop: 35, display: 'flex', flexDirection: 'column' }}>
                                                <h5 style={{ color: '#fff' }}>{this.state.title}</h5>
                                                <div style={{ display: 'flex', flexDirection: 'row', height: '90%', justifyContent: 'space-around', overflowY: 'auto' }}>
                                                    <div className="App">
                                                        <div>
                                                            {this.state.todos.map((item, index) => (
                                                                <div key={index} className="droptarget" onDrop={(event) => this.leftDrop(event)} onDragOver={(event) => this.allowDrop(event)} id={index}>
                                                                    <img onDragStart={(event) => this.dragStart(event)} onDrag={(event) => this.drag(event)} onDragEnd={(event) => this.dragEnd(event)} draggable="true" id={"dragtarget" + index} src={item.left_content} style={{ height: 100, width: 100 }} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div>
                                                            {this.state.todos.map((item, index) => (
                                                                <div key={index} className="droptarget" onDrop={(event) => this.rightDrop(event)} onDragOver={(event) => this.allowDrop(event)} id={index} >
                                                                    <span id={"text" + index} style={{ color: "#fff" }}>{item.right_content}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div>
                                                <hr color='#fff' />
                                                <div className="text-center">
                                                    <button className="btn" disabled={this.state.done_button_state} onClick={() => { this.handleDoneButton(this.props.current_index + 1) }} style={this.state.done_button_state ? styles.disable_done_btn : styles.done_btn}>
                                                        {this.state.done_button_state ? this.state.prompt : this.state.done_text}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{ backgroundColor: '#34baeb', backgroundImage: `url(${this.state.course_image})`, backgroundPosition: 'center', backgroundSize: 'cover', zIndex: 15, height: 550, top: -30, left: -30, margin: 30, visibility: this.state.prev_review ? "hidden" : "visible", position: 'absolute', paddingTop: 40 }}>
                                            <div>
                                                <div style={{ paddingRight: 50, paddingLeft: 50, paddingTop: 65 }}>
                                                    <div className="text-center">
                                                        <button onClick={this.handleReviewLastSlide} className="btn" style={styles.previewbutton}>
                                                            Review last slide
                                                    </button>
                                                    </div>
                                                    <div className="text-center">
                                                        <button onClick={this.handleRestartLesson} className="btn" style={styles.previewbutton}>
                                                            Restart lesson
                                                    </button>
                                                    </div>
                                                    <div className="text-center">
                                                        <button onClick={this.handleCancel} className="btn" style={styles.previewbutton}>
                                                            Cancel
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12" style={{ paddingTop: 10, backgroundColor: '#fff', marginLeft: 0.1 }}>
                                <div className="col-4">
                                    <Button variant="default" onClick={() => { this.handlePrevButton(this.props.current_index - 1) }} className="btn btn-light" inline-block="true" style={{ marginBottom: 10 }}><Icon icon={smallLeft} size={20} /></Button>
                                </div>
                                <div className="col-4 text-center" style={{ paddingTop: 10 }}>
                                    <span >Slide {this.props.current_index + 1}</span>
                                </div>
                                <div className="col-4">
                                    <Button onClick={() => { this.handleDoneButton(this.props.current_index + 1) }} variant="default" className="btn btn-light" inline-block="true" style={{ marginBottom: 10 }}><Icon icon={smallRight} size={20} /></Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-7 col-sm-12">
                        <div className="card-sm" >
                            <div className="card-content block-xl" style={{ height: 550, overflowY: 'scroll', overflowX: 'hidden' }}>
                                <h5 className="text-left" style={{ paddingBottom: 10 }}>Drag to match</h5>
                                <div className="text-left">
                                    <div className="form-group">
                                        <div className="input-group-prepend" style={styles.textbox}>
                                            <span className="input-group-text" style={styles.text}>Title*</span>
                                        </div>
                                        <input type="text" className="form-control" id="title" minLength={2} maxLength={250} value={this.state.title} onChange={this.handleChangeTitle} onBlur={this.handleTitleValidation} />
                                        <label className="input-error error_title"></label>
                                    </div>
                                    <div style={{ marginBottom: 10 }}>
                                        <Accordion style={{ textAlign: 'left' }} defaultActiveKey="0">
                                            <div style={{ backgroundColor: '#EEF2F6', marginTop: -5 }}>
                                                <div style={{ height: 40 }} eventkey="0">
                                                    <h5>List</h5>
                                                </div>
                                                <Accordion.Collapse eventKey="0">
                                                    <div>
                                                        {this.state.todos.map((item, i) => (
                                                            <Card key={i} style={{ padding: 5, marginTop: 10 }}>
                                                                <div className="form-group">
                                                                    <div className="input-group-prepend" style={styles.textbox}>
                                                                        <span className="input-group-text" style={styles.text} >Left*</span>
                                                                    </div>
                                                                    <input
                                                                        style={{ display: 'none' }}
                                                                        ref={input => { this[`textInput${i}`] = input }}
                                                                        id={"file1" + i}
                                                                        className="upload"
                                                                        className="mr-3"
                                                                        onChange={this.handleChangeContent.bind(this, i)}
                                                                        type="file"
                                                                        accept="image/*"
                                                                    />
                                                                    <Button variant="default" style={{ backgroundColor: '#E6EBF0' }} data-key={i} onClick={this.handleClick(i)} block>
                                                                        Click a new file here to change image
                                                                </Button>
                                                                    <div className="row col-12 m-0" style={{ padding: '15px 5px' }}>
                                                                        <div className="progress-wrapper flex-column d-flex justify-content-center col-11 p-0 pr-1">
                                                                            <div id={"progress-bar-file1" + i} className="progress"></div>
                                                                        </div>
                                                                        <div className="col-1 p-0" id={"Video_uploading_percent" + i}></div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <div className="input-group-prepend" style={styles.textbox}>
                                                                        <span className="input-group-text" style={styles.text} >Right*</span>
                                                                    </div>
                                                                    <input type="text" className="form-control" id={"right_content" + i} value={item.right_content} onChange={this.handleRightContent.bind(this, i)} minLength={2} maxLength={30} onBlur={this.rightContentValidation.bind(this, i)} />
                                                                    <label className={"input-error error_right_content" + i}></label>
                                                                </div>
                                                                <div >
                                                                    <Button variant="default" style={{ backgroundColor: '#E6EBF0' }} disabled={this.state.todos.length == 2 ? true : false} block onClick={this.handleSectionStatusPopupOpen.bind(this, i)}>
                                                                        <Icon size={20} icon={trashO} style={{ paddingRight: 10 }} />
                                                                    Remove this section
                                                                </Button>
                                                                </div>
                                                            </Card>
                                                        ))}

                                                        <Modal size="sm" show={this.state.PublishedSectionPopup} onHide={this.handlePublishedSectionPopup}>
                                                            <Modal.Body>Are you sure you want to remove this?</Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={this.handlePublishedSectionPopup}>No</Button>
                                                                <Button style={styles.confirmButton} onClick={() => this.Remove()}>Yes</Button>
                                                            </Modal.Footer>
                                                        </Modal>


                                                        <div style={{ marginTop: 10, color: '#fff' }}>
                                                            <Button variant="default" disabled={this.state.todos.length == 3 ? true : false} onClick={this.Add.bind(this)} style={{ backgroundColor: '#223042', color: '#fff' }} block>
                                                                <Icon size={20} icon={plus} style={{ paddingRight: 10, color: '#fff' }} />
                                                            Add a section
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Accordion.Collapse>
                                            </div>
                                        </Accordion>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group-prepend" style={styles.textbox}>
                                            <span className="input-group-text" style={styles.text} >Answer Text</span>
                                        </div>
                                        <textarea type="text" className="form-control" maxLength={150} value={this.state.answer_text} onChange={this.handleChangeAnswerText} />
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group-prepend" style={styles.textbox}>
                                            <span className="input-group-text" style={styles.text}>Correct Reinforcement*</span>
                                        </div>
                                        <input type="text" className="form-control" id="correct_reinforcement" value={this.state.correct_reinforcement} minLength={2} maxLength={50} onChange={this.handleChangeCorrectAns} onBlur={this.correct_reinforcementValidation} />
                                        <label className="input-error error_correct_reinforcement"></label>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group-prepend" style={styles.textbox}>
                                            <span className="input-group-text" style={styles.text}>Incorrect Reinforcement*</span>
                                        </div>
                                        <input type="text" className="form-control" id="incorrect_reinforcement" value={this.state.incorrect_reinforcement} minLength={2} maxLength={50} onChange={this.handleChangeIncorrectAns} onBlur={this.incorrect_reinforcementValidation} />
                                        <label className="input-error error_incorrect_reinforcement"></label>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group-prepend" style={styles.textbox}>
                                            <span className="input-group-text" style={styles.text} >Prompt*</span>
                                        </div>
                                        <input type="text" className="form-control" id="prompt" value={this.state.prompt} minLength={2} maxLength={50} onChange={this.handleChangePrompt} onBlur={this.promptValidation} />
                                        <label className={"input-error error_prompt"}></label>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group-prepend" style={styles.textbox}>
                                            <span className="input-group-text" style={styles.text} >Done Text*</span>
                                        </div>
                                        <input type="text" className="form-control" id="done_text" value={this.state.done_text} minLength={2} maxLength={30} onChange={this.handleChangeDone_text} onBlur={this.doneTextValidation} />
                                        <label className={"input-error error_done_text"}></label>
                                    </div>
                                </div>
                            </div>
                            <div className="text-left " style={{ paddingTop: 10, paddingBottom: 10 }}>
                                <button onClick={this.handleSubmit} className="btn btn-dark" style={{ width: 150 }}>Save</button>
                                <div id="snackbar"></div>
                                <Modal size="sm" show={this.state.image_error_popup} onHide={() => this.setState({ image_error_popup: false })}>
                                    <Modal.Body>Only images are accepted.</Modal.Body>
                                    <Modal.Footer>
                                        {/* <Button variant="secondary" onClick={this.handleClose}>No</Button> */}
                                        <Button variant="primary" onClick={() => this.setState({ image_error_popup: false })} block>Ok</Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                // </div>
            )
        }
    }
}